export default defineAppConfig({
    ui: {
        colors: {
            primary: 'indigo',
        },
    },
})